import { AxiosRequestConfig } from 'axios';

import {
  StudentInAssignmentProgress,
  StudentInKlassBase,
  StudentShared,
} from '../../../sdk/src/shared';
import { BASE_API } from '../utils';

export interface KlassAssignmentDetailStudent
  extends StudentInAssignmentProgress {
  pointsToFinish: number;
  student: StudentShared;
  studentInClass: StudentInKlassBase;
  studentInClassId: string;
}

export interface KlassAssignmentDetail {
  assignedAt: string;
  name: string;
  pointsRequiredTotal: number;
  pointsRequiredNewSkills: number;
  pointsRequiredSpiralReview: number;
  releaseDate: string | null;
  students: KlassAssignmentDetailStudent[];
  studentsCompleted: string;
}

interface ShowConfig extends AxiosRequestConfig {
  method: 'GET';
  url: `/classes/${string}/assignments/${string}`;
}

/**
 * GET /vo/v1/classes/{classId}/assignments/{classAssignmentId}
 */
export const show = (
  classId: string,
  classAssignmentId: string,
): ShowConfig => {
  return {
    baseURL: BASE_API,
    method: 'GET',
    url: `/classes/${classId}/assignments/${classAssignmentId}`,
  } as const;
};
